








































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateIndustryRequest from '@/models/Industries/CreateIndustryRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'IndustryCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateIndustryRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateIndustryRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
       
    await AgencySettingsModule.createIndustry(this.entity)
    this.dialog = false;
  }
}
